// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 66) return "static/chunks/66-b23a706053eeb2d7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"32b953142426eacf","955":"c2f7d75b55df3a21"}[chunkId] + ".js";
};